export const graphColors = {
  graphBlue1: '#262984',
  graphBlue2: '#0065B2',
  graphBlue3: '#009CDB',
  graphBlue4: '#A5CCEC',
  graphGreen3: '#00AF43',
  graphYellow2: '#F3F38C',
  graphYellow: '#F9F039',
  graphRed4: '#FF8D28',
  graphGreen2: '#008B3E',
  graphPurple1: '#631E85',
  graphGreen1: '#005E32',
  graphGreen4: '#CEE02C',
  graphYellow3: '#EFF5C7',
  graphRed3: '#FF532D',
  graphRed1: '#C6212C',
  graphRed2: '#FF3C35'
}

export const haulrColors = {
  haulrBlue1: '#023059',
  haulrBlue2: '#2d77A6',
  haulrBlue3: '#699EBF',
  haulrGreen1: '#0D3D28',
  haulrGreen2: '#1A7D52',
  haulrOrange: '#BD3E2A',
  haulrRust: '#7D281B',
  haulrBrown: '#3D140D'
}
